import * as React from 'react'
import Downshift from 'downshift'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

function renderInput(inputProps) {
  const { InputProps, disabled, classes, ref, showClearButton, onClear, ...other } = inputProps

  return (
    <TextField
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot
        },
        ...InputProps,
        endAdornment: showClearButton ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation()
                if (onClear) {
                  onClear()
                }
              }}
              style={{
                padding: 6,
                margin: 0,
                color: '#999',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#666'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#999'
              }}
            >
              <CloseIcon style={{ fontSize: 18 }} />
            </IconButton>
          </div>
        ) : null
      }}
      disabled={disabled}
      variant="outlined"
      size="small"
      {...other}
    />
  )
}

function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
  const isHighlighted = highlightedIndex === index
  const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1

  return (
    <MenuItem
      {...itemProps}
      id={`auto-complete-${selectedItem.split(' ').join('-')}-${highlightedIndex}-option`}
      key={suggestion.label}
      selected={isHighlighted}
      name={suggestion.label}
      component="div"
      style={{
        fontWeight: isSelected ? 600 : 400,
        padding: '12px 16px',
        fontSize: '14px',
        minHeight: '48px',
        backgroundColor: isHighlighted ? '#f5f5f5' : 'transparent',
        borderBottom: '1px solid #f0f0f0',
        transition: 'background-color 0.2s ease',
        cursor: 'pointer'
      }}
    >
      {suggestion.label}
    </MenuItem>
  )
}

function getSuggestions(inputValue, suggestions, showAll, maxItems = 20) {
  let count = 0

  // Treat default values as empty - show all suggestions
  const searchValue = inputValue === 'All Organizations' || inputValue === 'All Channels' ? '' : inputValue

  return suggestions.filter((suggestion) => {
    const keep =
      (!searchValue || suggestion.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) &&
      (showAll || count < maxItems)

    if (keep) {
      count += 1
    }

    return keep
  })
}

const styles = (theme) => ({
  root: {
    flexGrow: 1
  },
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  paper: {
    position: 'absolute',
    zIndex: 1000,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
    maxHeight: 960,
    overflow: 'auto',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    border: '1px solid #e0e0e0'
  },
  inputRoot: {
    flexWrap: 'wrap'
  }
})

function IntegrationDownshift(props) {
  const { classes, input, placeholder, suggestions, disabled, showAll, showClearButton, onClear, ...other } = props
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  return (
    <div className={classes.root}>
      <Downshift
        onInputValueChange={(inputValue) => {
          input.onChange(inputValue)
        }}
        onChange={(selectedItem) => {
          if (selectedItem) {
            input.onChange(selectedItem)
            setIsMenuOpen(false)
          }
        }}
        selectedItem={input.value}
        isOpen={isMenuOpen}
        onOuterClick={() => {
          setIsMenuOpen(false)
          if (input.onBlur) {
            input.onBlur()
          }
        }}
      >
        {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
          <div className={classes.container}>
            {renderInput({
              fullWidth: true,
              classes,
              disabled,
              showClearButton,
              onClear,
              InputProps: getInputProps({
                placeholder,
                id: 'integration-downshift-simple',
                value: input.value,
                onFocus: (e) => {
                  setIsMenuOpen(true)
                  if (input.onFocus) {
                    input.onFocus(e)
                  }
                },
                onBlur: (e) => {
                  // Don't close immediately - let onOuterClick handle it
                  // This allows clicks on menu items to work
                }
              }),
              error: other.error
            })}
            {isOpen ? (
              <Paper className={classes.paper} elevation={8}>
                {getSuggestions(inputValue, suggestions, showAll).map((suggestion, index) =>
                  renderSuggestion({
                    suggestion,
                    index,
                    itemProps: getItemProps({ item: suggestion.label }),
                    highlightedIndex,
                    selectedItem
                  })
                )}
              </Paper>
            ) : null}
          </div>
        )}
      </Downshift>
    </div>
  )
}

// @ts-ignore
export default withStyles(styles)(IntegrationDownshift)
